import React, { Component } from "react";
import NegaKoseImage from "../../images/icon-service-light-3-70x62.png"
import BradaImage from "../../images/icon-service-light-4-70x62.png"
import SisanjeImage from "../../images/icon-service-light-1-70x62.png"
import BrijanjeImage from "../../images/icon-service-light-2-70x62.png"
import PozadinaLeftImage from "../../images/home-three-2-910x800.jpg"
import PozadinaRightImage from "../../images/home-three-3-1011x800.jpg"

class ServicesSectionComponent extends Component {

    
    render() { 
        return (    <section className="bg-white" style={{paddingTop:150}} id="onama">
        <div className="shell-fluid shell-condensed">
          <div className="range range-condensed">
            <div className="cell-md-6 cell-md-6-mod-1 image-wrap-left bg-white bg-image"
              style={{backgroundImage: 'url('+PozadinaLeftImage+')'}}>
              <div className="image-wrap-inner">
                <h2>O NAMA</h2>
                <p className="big">Frizerski salon namenjen muškarcima koji vole kvalitetnu uslugu, prijatan ambijent uz gratis piće.<br /><br /> Višegodisnji rad tražio je i novi napredak, što je rezultiralo pokretanjem samostalnog muškog modnog frizerskog studija 2020. godine.
Od tada do danas svakodnevno osluškujući potrebe mušterija, praćenjem svetskih trendova, stručnom edukacijom, danas smo u prilici da ponudimo trending muške frizure.
Posebno bi izdvojili našu specijalnost, a to je fejd stil uz koji Vaš odraz u ogledalu odiše modom i mladošću.
Uz modernu frizuru ide i moderna brada, a to je posebno zadovoljstvo kome itekako posvećujemo pažnju.
Naša najveća nagrada je Vaš zadovoljan osmeh i poverenje koje nam iznova ukazujete.
                  </p>
              </div>
            </div>
            <div className="cell-md-6 cell-md-6-mod-2 image-wrap-right bg-gray-dark bg-image"
              style={{backgroundImage: 'url('+PozadinaRightImage+')'}} id="usluge">
              <div className="image-wrap-inner">
                <div className="range range-condensed range-inner-bordered">
                  <div className="cell-xs-6">
                    <article className="box-icon">
                      <figure className="box-icon-image"><img src={NegaKoseImage} alt="" width="70"
                          height="62" />
                      </figure>
                      <p className="box-icon-header"><a className="link-underlined" href="/zakazivanje?usluga=sisanjebrada">ŠIŠANJE KOSE I BRADE</a></p>
                      <p className="box-icon-text"></p>
                    </article>
                  </div>
                  <div className="cell-xs-6">
                    <article className="box-icon">
                      <figure className="box-icon-image"><img src={BrijanjeImage} alt="" width="70"
                          height="62" />
                      </figure>
                      <p className="box-icon-header"><a className="link-underlined" href="/zakazivanje?usluga=brada">SREĐIVANJE BRADE</a></p>
                      <p className="box-icon-text"></p>
                    </article>
                  </div>
                  <div className="cell-xs-6">
                    <article className="box-icon">
                      <figure className="box-icon-image"><img src={SisanjeImage} alt="" width="70"
                          height="62" />
                      </figure>
                      <p className="box-icon-header"><a className="link-underlined" href="/zakazivanje?usluga=sisanje">ŠIŠANJE</a></p>
                      <p className="box-icon-text"></p>
                    </article>
                  </div>
                  <div className="cell-xs-6">
                    <article className="box-icon">
                    <figure className="box-icon-image"><img src={BradaImage} alt="" width="70"
                          height="62" />
                      </figure>
                      <p className="box-icon-header"><a className="link-underlined" href="/zakazivanje?usluga=sisanjebrada">NEGA KOSE I BRADE</a></p>
                      <p className="box-icon-text"></p>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>);
    }
}
 
export default ServicesSectionComponent;